import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ParlonsDeVotreProjet from "./sections/ParlonsDeVotreProjet";
import NotreEmplacement from "./sections/NotreEmplacement";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ParlonsDeVotreProjet />
      <NotreEmplacement />
      <Footer />
    </div>;
}